import { Modal, Space, Button } from 'antd'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faExclamationCircle } from '@fortawesome/pro-solid-svg-icons'
import { orange } from '@ant-design/colors'
import { Route } from '../routingApi'
import { useSaveRouteActiveMutation } from '../routingQueries'

export type Props = {
  visible: boolean
  onCancel: () => void
  route: Route | null
  onSuccess?: () => void
}

const InactivateRouteModal = ({ visible, onCancel, route, onSuccess }: Props) => {
  const saveRouteActiveMutation = useSaveRouteActiveMutation()

  const handleInactivate = () => {
    if (route) {
      saveRouteActiveMutation.mutate({ routeId: route.id, active: false }, {
        onSuccess: () => {
          onSuccess?.()
          onCancel()
        }
      })
    }
  }

  if (!route) {
    return null
  }

  return (
    <Modal
      open={visible}
      title={
        <Space>
          <FontAwesomeIcon icon={faExclamationCircle} color={orange.primary} />
          <span>Inactivate Route?</span>
        </Space>
      }
      onCancel={onCancel}
      footer={[
        <Button key="cancel" onClick={onCancel} disabled={saveRouteActiveMutation.isLoading}>
          Cancel
        </Button>,
        <Button key="inactivate" type="primary" onClick={handleInactivate} loading={saveRouteActiveMutation.isLoading}>
          Inactivate
        </Button>
      ]}
      closable={true}
      maskClosable={false}
      width={500}
    >
      <p>
        Are you sure you want to make <strong>{route.name}</strong> inactive? This action will{' '}
        <strong>remove any existing future scheduled events from the calendar</strong>.
      </p>
    </Modal>
  )
}

export default InactivateRouteModal
